module.exports = "<ul class=bc-bordered-list ng-class=\"{'bc-bordered-list-horizontal': horizontal}\"> <div ng-transclude=contentSlot></div> </ul> ";